import {
  CRUD_GET_LIST_SUCCESS,
  CRUD_GET_ONE_SUCCESS,
  CRUD_CREATE_SUCCESS,
  CRUD_UPDATE_SUCCESS,
} from 'actions/dataActions';
import {CLEAR_CURD_RESOURCE_DATA} from "actions";

export default resource => (previousState = 0, { type, payload, meta }) => {
  if (!meta || meta.resource !== resource) {
    return previousState;
  }
  switch (type) {
    case CLEAR_CURD_RESOURCE_DATA:
      return 0;
    case CRUD_GET_LIST_SUCCESS:
      return payload.total;
    case CRUD_GET_ONE_SUCCESS:
    case CRUD_CREATE_SUCCESS:
    case CRUD_UPDATE_SUCCESS:
      return 1;
    default:
      return previousState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/resource/list/total.js